module.exports = __webpack_public_path__ + "media/01_高清1080P.dd5b0f82.mp4";